import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "border-top"
    }}>{`border-top`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v2.0`}</p>
    <p>{`Shorthand for specifying the `}<a parentName="p" {...{
        "href": "../border-top-style/"
      }}>{`style`}</a>{`, `}<a parentName="p" {...{
        "href": "../border-top-color/"
      }}>{`color`}</a>{`, and `}<a parentName="p" {...{
        "href": "../border-top-width"
      }}>{`width`}</a>{` of the top border.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Warning`}</strong></p>
      <p parentName="blockquote">{`An element's border can only consist of a single color. If you specify
multiple border colors, you'll see a warning on the JavaScript console.`}</p>
    </blockquote>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/border-top"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/border-top`}</a>{`  `}</p>
    <h2 {...{
      "id": "quirks-and-exceptions"
    }}>{`Quirks and Exceptions`}</h2>
    <ul>
      <li parentName="ul">{`UXP does not support the `}<inlineCode parentName="li">{`content-sizing`}</inlineCode>{` box layout model. As such, the width and height of all elements include the padding and border width.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      